import { styled } from "styled-components";

import {
    colorCSS,
    fontSizes,
    minWidth,
    shadow,
    SMALL_NAV_PX_HEIGHT,
    SUB_NAV_PX_HEIGHT,
    zIndex
} from "../../../styles";
import { redundantCssFromKebab } from "../../../styles/redundant-css";

//margin to make room for focus outline
const buttonMargin = 3;

export const Button = styled.button`
    ${redundantCssFromKebab("background-color", "transparent")}
    ${redundantCssFromKebab("border", "0")}
    ${redundantCssFromKebab("color", `${colorCSS("N900")}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
    ${redundantCssFromKebab(
        "height",
        `${SUB_NAV_PX_HEIGHT - buttonMargin * 2}px`
    )}
    ${redundantCssFromKebab("margin", `${buttonMargin}px`)}
    ${redundantCssFromKebab("padding", "0.75rem 1rem")}
    ${redundantCssFromKebab("position", "relative")}
    ${redundantCssFromKebab("text-align", "left")}
    ${redundantCssFromKebab("width", "calc(100% - 6px)")}
    &::after {
        ${redundantCssFromKebab(
            "background-image",
            'url(\'data:image/svg+xml,%3Csvg fill="%23172b4d" height="8" viewBox="0 0 13 8" width="13" xmlns="http://www.w3.org/2000/svg" %3E%3Cpath d="m11.7305.59279c.3626.362629.3885.93447.0777 1.32699l-.0777.08722-4.99999 4.99999c-.36263.36263-.93446.38853-1.32697.0777l-.08725-.0777-4.999959-4.99997c-.3905249-.39052-.3905242-1.023685 0-1.414209.362629-.36263.934469-.388553 1.326989-.077728l.08722.077728 4.29292 4.292139 4.29284-4.29216c.3626-.36263.9345-.388532 1.327-.077707z" /%3E%3C/svg%3E\')'
        )}
        ${redundantCssFromKebab("background-position", "center center")}
        ${redundantCssFromKebab("background-repeat", "no-repeat")}
        ${redundantCssFromKebab("background-size", "contain")}
        ${redundantCssFromKebab("content", '""')}
        ${redundantCssFromKebab("height", "1rem")}
        ${redundantCssFromKebab("margin-top", "-0.5rem")}
        ${redundantCssFromKebab("position", "absolute")}
        ${redundantCssFromKebab("right", "1rem")}
        ${redundantCssFromKebab("top", "50%")}
        ${redundantCssFromKebab("transition", "transform 0.5s ease")}
        ${redundantCssFromKebab("width", "1rem")}
    }
    &[data-open="true"]::after {
        ${redundantCssFromKebab("transform", "rotateX(180deg)")}
    }
`;

export const Nav = styled.div`
    ${redundantCssFromKebab("background-color", `${colorCSS("N0")}`)}
    ${redundantCssFromKebab("box-shadow", `${shadow.normal}`)}
    ${redundantCssFromKebab("height", `${SUB_NAV_PX_HEIGHT}px`)}
    ${redundantCssFromKebab(
        "max-height",
        `calc(100% - ${SMALL_NAV_PX_HEIGHT}px)`
    )}
    ${redundantCssFromKebab("overflow", "auto")}
    ${redundantCssFromKebab("position", "fixed")}
    ${redundantCssFromKebab("top", `${SMALL_NAV_PX_HEIGHT}px`)}
    ${redundantCssFromKebab("width", "100%")}
    ${redundantCssFromKebab("z-index", `${zIndex.subNav}`)}
`;

export const Shroud = styled.div`
    ${redundantCssFromKebab("background-color", `${colorCSS("N900", 0)}`)}
    ${redundantCssFromKebab("height", "0")}
    ${redundantCssFromKebab("left", "0")}
    ${redundantCssFromKebab("position", "fixed")}
    ${redundantCssFromKebab("right", "0")}
    ${redundantCssFromKebab("top", "0")}
    ${redundantCssFromKebab(
        "transition",
        "background-color 0.6s ease, height 0s linear 0.6s"
    )}
    ${redundantCssFromKebab("z-index", `${zIndex.subNavShroud}`)}
    &[data-open="true"] {
        ${redundantCssFromKebab("background-color", `${colorCSS("N900", 0.5)}`)}
        ${redundantCssFromKebab("cursor", "pointer")}
        ${redundantCssFromKebab("height", "100vh")}
        ${redundantCssFromKebab(
            "transition",
            "background-color 0.6s ease, height 0s linear"
        )}
        ${Nav} {
            ${redundantCssFromKebab("height", "auto")}
        }
    }
    @media ${minWidth.lg} {
        ${redundantCssFromKebab("display", "none")}
    }
`;
